import './AppHeader.scss';
import {useEffect, useMemo, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {logout} from '../../../api/walletAxios';
import {select as selectLoggedInUser} from '../../../store/loggedInUser';
import {selectSectionTitle} from '../../../store/navigation';

const getInitials = (firstName = '', lastName = '') => {
    const a = (firstName.trim()[0] || '').toUpperCase();
    const b = (lastName.trim()[0] || '').toUpperCase();
    return (a + b) || 'U';
};

const AppHeader = () => {
    const loggedInUser = useSelector(selectLoggedInUser);
    const sectionTitle = useSelector(selectSectionTitle);

    const fullName = useMemo(() => {
        const f = loggedInUser?.firstName ?? '';
        const l = loggedInUser?.lastName ?? '';
        return `${f} ${l}`.trim() || 'User';
    }, [loggedInUser]);

    const initials = useMemo(
        () => getInitials(loggedInUser?.firstName, loggedInUser?.lastName),
        [loggedInUser],
    );

    const changeTheme = () => {
        const theme = (localStorage.getItem('theme') || 'dark') === 'dark' ? 'light' : 'dark';
        document.documentElement.dataset.theme = theme;
        localStorage.setItem('theme', theme);
    };

    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const onDocClick = (e) => {
            if (!menuRef.current) return;
            if (!menuRef.current.contains(e.target)) setMenuOpen(false);
        };
        const onEsc = (e) => { if (e.key === 'Escape') setMenuOpen(false); };

        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onEsc);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onEsc);
        };
    }, []);

    return (
        <header className="wallet-header">
            <div className="wallet-header__brand">
                <span className="wallet-header__title">Capital {sectionTitle && `· ${sectionTitle}`}</span>
            </div>

            <div className="wallet-header__spacer"/>

            <div className="wallet-header__profile" ref={menuRef}>
                <button
                    className="wallet-header__profileBtn"
                    onClick={() => setMenuOpen(v => !v)}
                    aria-haspopup="menu"
                    aria-expanded={menuOpen}
                    type="button"
                >
                    <span className="wallet-header__avatar" aria-hidden="true">{initials}</span>
                    <span className="wallet-header__name" title={fullName}>{fullName}</span>
                </button>

                {menuOpen && (
                    <div className="wallet-header__menu" role="menu" aria-label="Profile menu">
                        <div className="wallet-header__menuHeader">
                            <div className="wallet-header__avatar wallet-header__avatar--big" aria-hidden="true">
                                {initials}
                            </div>
                            <div className="wallet-header__menuMeta">
                                <div className="wallet-header__menuName">{fullName}</div>
                                <div className="wallet-header__menuHint">Account</div>
                            </div>
                        </div>

                        <div className="wallet-header__menuDivider"/>

                        <button className="wallet-header__menuItem" role="menuitem" type="button"
                                onClick={changeTheme}>
                            Theme
                        </button>

                        <div className="wallet-header__menuDivider"/>

                        <button
                            className="wallet-header__menuItem wallet-header__menuItem--danger"
                            role="menuitem"
                            type="button"
                            onClick={logout}
                        >
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
};

export default AppHeader;